import { render, staticRenderFns } from "./PostWithMedia.vue?vue&type=template&id=635a34b7&scoped=true"
import script from "./PostWithMedia.vue?vue&type=script&lang=js"
export * from "./PostWithMedia.vue?vue&type=script&lang=js"
import style0 from "./PostWithMedia.vue?vue&type=style&index=0&id=635a34b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a34b7",
  null
  
)

export default component.exports